import { render, staticRenderFns } from "./Emergency-Contact.vue?vue&type=template&id=603574b0&"
import script from "./Emergency-Contact.vue?vue&type=script&lang=js&"
export * from "./Emergency-Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports